<template>
  <v-card class="login-dialog__content" :class="layout == 'portal' ? 'fixit-background-gradient' : ''"
    :style="!$vuetify.breakpoint.smAndDown ? 'height: 600px' : ''">
    <v-app-bar v-if="!simplifiedLogin" flat color="rgba(0, 0, 0, 0)">
      <v-btn color="primary" rounded text @click="changeView('terms_of_use')">
        <v-icon size="30">fxt-info-circle</v-icon>
        <span class="ml-2">
          Vilkår for bruk {{ code }}
        </span>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="!isProfile" color="primary" icon @click="close">
        <v-icon size="30">fxt-close</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="login-dialog__content-container" :class="[simplifiedLogin ? 'simplified-login-container' : (layout == 'portal' ? '' : 'justify-center')]">
      <div class="login-dialog__content-container--logo">
        <!-- TODO: Change to use url from umbraco -->
        <img
          :src="layout == 'portal' ? 'https://umbraco.fixit.no/media/1348/fixit_logo_lilla.png' : $store.getters['cmsConfigHomepage/getLogoLarge'] ? $store.getters['cmsConfigHomepage/getLogoLarge'] : $store.getters['webshop/getChainLogoUrl']"
          alt="logo" style="object-fit: contain; margin: auto" loading="eager"
          :class="layout == 'portal' ? '' : 'pb-5'" />
        <span v-if="layout == 'portal' && !simplifiedLogin" class="login-dialog__content-container--text pt-5">Din personlige inngang til
          frisør-, velværesalonger og klinikker over hele Norge.</span>
      </div>

      <div v-if="simplifiedLogin" class="simplified-content">
        <v-progress-circular
          indeterminate
          color="primary"
          class="my-8"
          size="64"
        ></v-progress-circular>
        <p>Du blir nå videresendt til fixit.no for innlogging</p>
      </div>
      <div v-else class="login-dialog__content-container--options" :style="layout == 'portal' ? '' : 'margin-bottom: 102px'">
        <v-btn elevation="0" block height="44px" color="#472449" dark rounded class="my-3"
          @click="useFixitOauthLogin ? oauthLogin('fixit') : changeView('login')">
          Logg inn med din bruker
        </v-btn>
        <v-btn elevation="0" outlined block height="44px" color="#222222" rounded class="mb-3"
          @click="oauthLogin('google')">
          Logg inn med <img :src="googleIcon" class="pl-2 pt-1" style="object-fit: contain;" />
        </v-btn>
        <v-btn elevation="0" outlined block height="44px" color="#222222" rounded class="mb-3"
          @click="oauthLogin('apple')">
          Logg inn med <img :src="appleIcon" class="pl-2 pt-1" style="object-fit: contain;" />
        </v-btn>
        <v-btn elevation="0" outlined block height="44px" color="#222222" rounded class="mb-3"
          @click="oauthLogin('vipps')">
          Logg inn med <img :src="vippsIcon" class="pl-2 pt-1" style="object-fit: contain;" />
        </v-btn>

        <p class="login-dialog__content-container--options__fine-print pb-5">Innlogging med Vipps er ikke koblet til betaling.</p>

        <v-btn elevation="0" block height="44px" outlined color="primary" dark rounded class="mt-3"
          @click="changeView('registration')">
          Ny hos oss? Lag ny bruker
        </v-btn>
      </div>
    </div>
    <div v-if="layout == 'chain' && !simplifiedLogin" class="login-dialog__content-container--footer d-flex justify-center align-center">
      <p class="login-dialog__content-container--footer__text ma-0">{{ chainName }} bruker <a
          :href="portalUrl()">Fixit</a> sine bestillingsløsninger. Fixit er din personlige inngang til frisør-,
        velværesalonger og klinikker over hele Norge.</p>
    </div>
  </v-card>
</template>
<script>
import AppSvc from "../../../services/app-svc";
import { setRefreshTokenCookie } from '@fixit/utils/src/functionFn';

export default {
  name: "the-selection",
  components: {},
  props: {
    apiUrl: {
      type: String,
      required: true,
    },
    isMounted: {
      type: Boolean,
      required: true,
    },
    oauthUrl: {
      type: String,
      required: true,
    },
    layout: {
      type: String,
      required: false,
      default: 'chain'
    },
    isProfile: {
      type: Boolean,
      required: false,
      default: false
    },
    useFixitOauthLogin: {
      type: Boolean,
      required: false,
      default: false
    },
    simplifiedLogin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      vippsIcon: require("../../../assets/img/vipps-logo-orange.png"),
      googleIcon: require("../../../assets/img/google-logo-login.svg"),
      appleIcon: require("../../../assets/img/apple-logo-black.svg"),
      fixitIcon: require('../../../assets/img/fixit-logo-white.png'),
      code: '',
      oauthEventListenerHandler: null
    };
  },
  computed: {
    chainName() {
      return this.$store.getters['cmsConfigHomepage/getChainName'] || 'Salongene'
    }
  },
  methods: {
    startRedirectTimer() {
      setTimeout(() => {
        this.oauthLogin('portal')
      }, 2000)
    },
    changeView(view) {
      // Track selected method
      if (this.layout === 'portal' && !this.isProfile) {
        if (view === 'login') {
          window.CONFIG.google.sendEventButtonClick('login-with-user', 'Logg inn med din bruker','' )
        }
      } 
      this.$emit("changeView", view);
    },
    close() {
      this.$emit("close");
    },
    portalUrl() {
      return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_URL : this.$config.PORTAL_URL
    },
    oauthLogin(type) {
      // Track selected method
      if (this.layout === 'portal' && !this.isProfile) {
          window.CONFIG.google.sendEventButtonClick('login-with-' + type, 'Logg inn med ' + type, '')
      } 

      let url = "";
      let redirectUrl = window.location.href;
      if (type === 'vipps') {
        if (this.useFixitOauthLogin) {
          url = window.location.href
          if (url.slice(-1) != '/') {
            url += '/'
          }
          url += `oauth-vipps-login?redirectUri=${encodeURI(redirectUrl)}`
        } else {
          url = this.oauthUrl + `?oauthTarget=vipps&redirectUri=${encodeURI(redirectUrl)}`
        }
        if (this.$route.query.siteId && this.$route.query.customerId) {
          url += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
        }
      } else if (type === 'google') {
        if (this.useFixitOauthLogin) {
          url = window.location.href
          if (url.slice(-1) != '/') {
            url += '/'
          }
          url += `oauth-google-login?redirectUri=${encodeURI(redirectUrl)}`
        } else {
          url = this.oauthUrl + `?oauthTarget=google&redirectUri=${encodeURI(redirectUrl)}`
        }
        if (this.$route.query.siteId && this.$route.query.customerId) {
          url += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
        }
      } else if (type === 'apple') {
        if (this.useFixitOauthLogin) {
          url = window.location.href
          if (url.slice(-1) != '/') {
            url += '/'
          }
          url += `oauth-apple-login?redirectUri=${encodeURI(redirectUrl)}`
        } else {
          url = this.oauthUrl + `?oauthTarget=apple&redirectUri=${encodeURI(redirectUrl)}`
        }
        if (this.$route.query.siteId && this.$route.query.customerId) {
          url += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
        }
      }
      else if (type === 'fixit') {
        url = window.location.href
        if (url.slice(-1) != '/') {
          url += '/'
        }
        url += 'oauth-login'
      }
      else if (type === 'portal') {
         let returnUrl = window.location.href;
          url = window.location.origin;
        if (url.slice(-1) != '/') {
          url += '/'
        }
         url += 'oauth-fixit-login' + '?returnUrl=' + encodeURI(returnUrl)
      }
      window.location.href = url
    },
        async oauthEventListener(event) {
      if (event.origin != this.oauthUrl) {
        return
      }

      if (event.data.oauthTarget === 'fixit') {
        let service = await AppSvc(this.useAxios ? this.$axios : null);
        let responseUrl = new URL(event.data.tokenUrl)
        if (responseUrl.searchParams.get('state') !== this.$route.query.state)
          return this.$emit('notify', {
            visible: true,
            duration: 3000,
            state: 'error',
            message: 'Påloggingen er utløpt, prøv igjen',
          })
        let oauthResponse = await service.OAuthLogin(event.data.tokenUrl)
        setRefreshTokenCookie(oauthResponse.data.refreshToken, oauthResponse.data.expiresIn, 'refreshTokenOauth')
        this.$axios.defaults.headers.common["Authorization"] = `Bearer ${oauthResponse.data.accessToken}`
        let user = await service.getCurrentUser(this.apiUrl)
        this.$emit('setUser', user)
      }
    }
  },
  async created() {
    this.oauthEventListenerHandler = this.oauthEventListener.bind(this);
    window.addEventListener("message", this.oauthEventListenerHandler, false);
    if (localStorage.getItem('origin') === 'fixitOAuth') {
      this.changeView('login')
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.oauthEventListenerHandler, false);
  }
};
</script>
<style lang="scss">
@import "../../../assets/styles/login.scss";

.simplified-login-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.simplified-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding-bottom: 50px;
}
</style>
